import { render, staticRenderFns } from "./settingDetail.vue?vue&type=template&id=f46d7b9e&scoped=true&"
import script from "./settingDetail.vue?vue&type=script&lang=js&"
export * from "./settingDetail.vue?vue&type=script&lang=js&"
import style0 from "./settingDetail.vue?vue&type=style&index=0&id=f46d7b9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46d7b9e",
  null
  
)

export default component.exports